/**
*部署需要注意路径地址的修改：
*PASSPORT_HOST，APP_HOST，INTERNAL_HOST，LOGIN_CHECK，CHANNEL
**/
const serverConfigs = require('./server.js')
export const ENV = process.env.VUE_APP_MODE
export const server = serverConfigs[ENV]
export const PASSPORT_HOST = server.passport
export const APP_HOST = server.app
export const INTERNAL_HOST = server.internal
export const LOGIN_CHECK = server.loginCheck
export const STARRY_HOST = server.starryAPI
export const CHANNEL = server.channel
export const STARRY_WEB = server.starryWeb
export const PASSPORT_API = '/api/v1'
export const VERSION = '3.1_23'
export const APP_KEY = 'CZUR_PASSPORT_WEB'
export const DEFAULT_PAGE = 'index.html'

export const OTHER_HOST = server.otherHost
export const HTTP_HEADER_KEY = {
  APP_KEY: 'App-Key',
  UDID: 'udid',
  CHANNEL: 'Channel',
  TOKEN: 'T-ID',
  USERID: 'U-ID'
}
export const COOKIE_KEY = {
  U_ID: 'U-ID',
  TOKEN: 'T-ID',
  USER_NAME: 'user',
  MODE: 'mode',
  COUNTRY_CODE: 'countryCode'
}
export const CALL_BACK = ''
export const R_CODE = {
  SUCCESS: 1000,
  INTERNAL_ERROR: 1001,
  INVALID_TOKEN: 1002,
  BAD_ACCESS: 1003,
  PWD_ERROR: 1004,
  USER_INACTIVE: 1005,
  CHANNEL_UNSUPPORT: 1006,
  INVALID_MOBILE: 1007,
  INVALID_EMAIL: 1008,
  SMS_MANY_REQUEST: 1009,
  SMS_SEND_10S: 1010,
  USER_EXIST: 1011,
  MAIL_MANY_REQUEST: 1012,
  MAIL_SEND_10S: 1013,
  INVALID_CODE: 1014,
  IMG_PRO_ERROR: 1015,
  IMG_PRO_ING: 1016,
  INVALID_USER_NAME: 1017,
  USER_NO_EXIST: 1018,
  TIME_OUT: 1019,
  IMG_NOT_FOUND: 1020,
  DEVICE_OCCUPIED: 1021,
  USER_USING_DEVICE: 1022,
  MANY_REQUEST_CODE: 1023,
  PWD_OLD_SAME: 1030,
  PWD_OLD_ERROR: 1031,
  NO_MOBILE_BIND: 1032,
  CODE_ERROR: 1033,
  MOBILE_USED_OTHERS: 1034,
  EMAIL_USED_OTHERS: 1035,
  PDF_PREPARING: 1039,
  SHARE_NO_FILE: 1070,
  SHARE_EXPIRED_FILE: 1071,
  SHARE_CODE_ERROR: 1072,
  SHARE_CODE_MANYTIME: 1073,
  INTERNAL_COUNTRY_CODE: 4002
}
export const documentSize = function () {
  var w = window
  var d = document
  var e = d.documentElement
  var g = d.getElementsByTagName('body')[0]
  var x = w.innerWidth || e.clientWidth || g.clientWidth
  var y = w.innerHeight || e.clientHeight || g.clientHeight
  return {width: x, height: y}
}
export const cookieSet = function (key, value) {
  var Days = 30
  var date = new Date()
  date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString()
}
export const cookieGet = function (key) {
  var result
  var mycookie = document.cookie
  var start2 = mycookie.indexOf(key + '=')
  if (start2 > -1) {
    var start = mycookie.indexOf('=', start2) + 1
    var end = mycookie.indexOf(';', start)
    if (end === -1) {
      end = mycookie.length
    }
    result = unescape(mycookie.substring(start, end))
  }
  return result
}
export const getLocalStore = function (key) {
  return localStorage.getItem(key)
}
export const setLocalStore = function (key, value) {
  localStorage.setItem(key, value)
}
export const getReqParam = function (param) {
  var url = window.location.search // 获取url中"?"符后的字串
  var theRequest = {}
  if (url.indexOf('?') !== -1) {
    var str = url.substr(1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
    }
  }
  return theRequest[param]
}
export const appendParam = function (url, param, value) {
  var archor = ''
  if (url.indexOf('#') > 0) {
    var strs = url.split('#')
    url = strs[0]
    archor = strs[1]
  }
  if (url.indexOf('?') >= 0) {
    url = url + '&'
  } else {
    url = url + '?'
  }
  url = url + param + '=' + encodeURIComponent(value)
  if (archor !== '') {
    url = url + '#' + archor
  }
  return url
}
// json data to form data
export const jsonToFormData = function (jsonObj) {
  var formData = new FormData()
  for (var key in jsonObj) {
    formData.append(key, jsonObj[key])
  }
  return formData
}
export const removeEmoji = function (strs) {
  strs = strs.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '')
  return strs
}
export const urlRemoveParam = function (param) {
  var url = window.location.href
  if (window.location.search.indexOf(param[0]) >= 0) {
    var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '')
    var params = window.location.search.substr(1)
    var strs = params.split('&')
    for (var m = 0; m < param.length; m++) {
      var one = param[m]
      for (var i = 0; i < strs.length; i++) {
        if (strs[i].indexOf(one) >= 0) {
          strs.splice(i, 1)
          break
        }
      }
    }
    if (strs.length > 0) {
      var search = strs.join('&')
      hosturl = hosturl + '?' + search
    }
    url = hosturl + window.location.hash
  }
  return url
}
export const monthFn = function (lang, month) {
  if (lang === 'en' || lang === 'ru_RU') {
    if (month === '01') {
      month = 'Jan'
    } else if (month === '02') {
      month = 'Feb'
    } else if (month === '03') {
      month = 'Mar'
    } else if (month === '04') {
      month = 'Apr'
    } else if (month === '05') {
      month = 'May'
    } else if (month === '06') {
      month = 'Jun'
    } else if (month === '07') {
      month = 'Jul'
    } else if (month === '08') {
      month = 'Aug'
    } else if (month === '09') {
      month = 'Sep'
    } else if (month === '10') {
      month = 'Oct'
    } else if (month === '11') {
      month = 'Nov'
    } else if (month === '12') {
      month = 'Dec'
    }
  }
  return month
}
export const local4Service = function () {
  var lang = this.lang()
  var local = lang.replace('-', '_')
  return local
}



// WEBPACK FOOTER //
// ./src/common/script/config.js